module.exports = (el) => {
  const notificationCountEl = $('.notifications-count');
  const countInfoEl = $('.notifications-count-info');
  const dropdown = $(el);
  const dropdownMenu = dropdown.find('ul.dropdown-menu .notifications-container');

  function refreshCount() {
    $.get(urlNotificationsCount, (res) => {
      updateCount(res.count);
      dropdown.trigger('update');
    })
  }

  function updateCount(count) {
    let message = __("You don't have any new messages");
    if (count === 0) {
      notificationCountEl.hide();
    } else {
      notificationCountEl.show();

      if (count > 1) {
        message = __('You have {count} messages', { count });
      } else {
        message = __('You have 1 message');
      }
    }

    countInfoEl.html(message);
    notificationCountEl.html(count);
  }

  function loadNotifications() {
    $.get(urlNotificationsLatest, (res) => {
      dropdownMenu.html(res.html);
      updateCount(res.count);
    });
    dropdown.trigger('update');
  }

  function onDropdownOpen() {
    loadNotifications();
  }

  function markAllAsRead(e) {
    e.preventDefault();

    const btn = $(this);
    btn.loading();

    $.get(urlNotificationMarkAllAsRead, () => {
      loadNotifications();
    }).always(() => {
      btn.loading('reset');
    });
  }

  function markAsRead(e) {
    e.preventDefault();

    const btn = $(this);
    btn.loading();

    const id = $(this).closest('.notification-item').data('id');

    $.get(`${urlNotificationMarkAsRead}?id=${id}`, () => {
      loadNotifications();
    }).always(() => {
      btn.loading('reset');
    });
  }

  function itemClick(e) {
    e.stopPropagation();
  }

  loadNotifications();

  dropdown.on('show.bs.dropdown', onDropdownOpen);
  $(document).delegate('.mark-notification-as-read', 'click', markAsRead);
  $(document).delegate('.notification-item', 'click', itemClick);

  $('.mark-all-notifications-as-read').click(markAllAsRead);

  dropdown.on("click", ".footer", function (e) {
    dropdown.hasClass('open') && e.stopPropagation();
  });
};
